export default "__VITE_ASSET__OSbu4HjB__"